// extracted by mini-css-extract-plugin
module.exports = {"contentImage":"landing_contentImage___YdCq","titleBlock":"landing_titleBlock__2Ik-P","title":"landing_title__3xdXX"};